"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=3812%3A457))
 * @lastsynced 2026-10-29T13:52:57.584Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const Redo = createSVGIcon(
  <path
    d="m18 12.857 5.143-5.143L18 2.571m5.143 5.143H7.714a6.857 6.857 0 0 0 0 13.714h8.571"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Redo",
  {
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
